import { FeatureCard, GameMode, GameSkin, StepCard } from '../types/site';

export const GAME_MODES: GameMode[] = [
  {
    id: 'classic',
    name: 'Classic Run',
    badge: 'Original',
    description: 'Solid walls, balanced speed, and pure old-school survival.',
    speed: 150,
    wallBehavior: 'solid'
  },
  {
    id: 'wrap',
    name: 'Infinity Loop',
    badge: 'Modern',
    description: 'Slide through walls and appear on the opposite edge to keep combos alive.',
    speed: 135,
    wallBehavior: 'wrap'
  },
  {
    id: 'turbo',
    name: 'Turbo Rush',
    badge: 'Challenge',
    description: 'Sharper reaction windows and faster pacing for leaderboard grinders.',
    speed: 95,
    wallBehavior: 'solid'
  }
];

export const GAME_SKINS: GameSkin[] = [
  {
    id: 'neon',
    name: 'Neon Grid',
    description: 'Electric cyan accents on a midnight arena.',
    palette: {
      accent: '#7cf7ff',
      accentSoft: 'rgba(124, 247, 255, 0.18)',
      panel: 'rgba(7, 14, 30, 0.88)',
      border: 'rgba(124, 247, 255, 0.28)',
      board: 'radial-gradient(circle at top, rgba(16, 41, 72, 0.85), rgba(4, 8, 22, 0.96))',
      cell: 'rgba(255, 255, 255, 0.05)',
      snake: '#60f2c2',
      snakeAlt: '#1fb3ff',
      head: '#bffff8',
      food: '#ff8c5f',
      foodGlow: 'rgba(255, 140, 95, 0.72)',
      text: '#f7fbff',
      muted: '#95a7c7',
      control: 'rgba(12, 21, 42, 0.94)',
      controlShadow: 'rgba(124, 247, 255, 0.22)'
    }
  },
  {
    id: 'sunset',
    name: 'Sunset Drift',
    description: 'Warm coral glows and a dusk arcade surface.',
    palette: {
      accent: '#ffbe7a',
      accentSoft: 'rgba(255, 190, 122, 0.2)',
      panel: 'rgba(38, 17, 31, 0.88)',
      border: 'rgba(255, 190, 122, 0.26)',
      board: 'radial-gradient(circle at top, rgba(90, 33, 58, 0.84), rgba(25, 11, 23, 0.97))',
      cell: 'rgba(255, 255, 255, 0.06)',
      snake: '#ffd76f',
      snakeAlt: '#ff7a90',
      head: '#fff2c5',
      food: '#8effc4',
      foodGlow: 'rgba(142, 255, 196, 0.7)',
      text: '#fffaf3',
      muted: '#d4b7bb',
      control: 'rgba(49, 21, 39, 0.93)',
      controlShadow: 'rgba(255, 190, 122, 0.24)'
    }
  },
  {
    id: 'forest',
    name: 'Forest Pulse',
    description: 'Emerald trails and softer organic contrast.',
    palette: {
      accent: '#93ffb8',
      accentSoft: 'rgba(147, 255, 184, 0.18)',
      panel: 'rgba(10, 24, 20, 0.9)',
      border: 'rgba(147, 255, 184, 0.25)',
      board: 'radial-gradient(circle at top, rgba(18, 54, 43, 0.82), rgba(7, 16, 13, 0.96))',
      cell: 'rgba(255, 255, 255, 0.045)',
      snake: '#7bf7a6',
      snakeAlt: '#39b86f',
      head: '#d8ffe7',
      food: '#ffd36b',
      foodGlow: 'rgba(255, 211, 107, 0.68)',
      text: '#f4fff9',
      muted: '#9dc0ae',
      control: 'rgba(10, 28, 20, 0.95)',
      controlShadow: 'rgba(123, 247, 166, 0.2)'
    }
  }
];

export const LANDING_FEATURES: FeatureCard[] = [
  {
    title: 'A full arcade world',
    description: 'From the landing page to the play arena, every screen is built to feel like part of one game universe.',
    accent: 'Brand'
  },
  {
    title: 'Touch-ready controls',
    description: 'Tap to start, swipe to steer, or use the on-screen D-pad when you want full control on mobile.',
    accent: 'Mobile'
  },
  {
    title: 'Modes with attitude',
    description: 'Swap between rule sets and visual themes to turn every run into a different kind of showdown.',
    accent: 'Gameplay'
  },
  {
    title: 'Play for the top spot',
    description: 'Create your player identity, chase bigger scores, and keep your name in the ranking conversation.',
    accent: 'Progress'
  }
];

export const QUICK_STEPS: StepCard[] = [
  {
    title: 'Choose your loadout',
    description: 'Pick the skin and game mode that match the kind of run you want to make.'
  },
  {
    title: 'Hit the grid',
    description: 'Keyboard, taps, and swipe gestures all feed into the same fast, responsive control system.'
  },
  {
    title: 'Own the leaderboard',
    description: 'Every strong run pushes your score higher and keeps the pressure on the next challenger.'
  }
];
